import PlayVideo from 'core/assets/icons/video/play_video.svg';
import PlayVideoBig from 'core/assets/icons/video/play_video_big.svg';
import { AnyObject } from "yup";
import React, { useState } from 'react';
import VideoYoutube from './VideoYoutube';
import Image from './../Image';
import { config } from 'core/config/app';
import CDialog from '../CDialog';
import { _t } from 'core/language';

export type IProps = {
  id?: string;
  className?: string;
  name?: string;
  showIcon?: boolean;
  showTime?: boolean;
  dataItem?: AnyObject;
  image?: string;
  handleClick?: (e: any) => void;
  type?: number;
  time?: string;
  active?: boolean;
  videoId?: string;
  classNameImg?: string;
};

export default function VideoListItem ({
  className,
  name,
  showIcon,
  showTime,
  dataItem,
  image,
  handleClick,
  type,
  time,
  active,
  videoId,
  classNameImg,
}: IProps) {
  const [isShowVideoYoutube, setShowVideoYoutube] = useState<boolean>(false);
  const [isNotVideoId, setIsNotVideoId] = useState<boolean>(false);
  const handleClickToDetail = () => {
    if (handleClick) {
      handleClick?.(dataItem);
    } else {
      // setShowVideoYoutube(true);
      //player video native
      if (!videoId) {
        setIsNotVideoId(true);
        return;
      }else{
        (window as any).webViewRequestPlayerVideo(`${config.youtubeUrl}${videoId}`, videoId);
      }
    }
  };

  return (
    <div>
      {type === 1 ? (
        <div className={`${className} rounded-lg`} onClick={handleClickToDetail}>
          <div className={`relative w-full`}>
            <Image
              src={image || ''}
              alt={name || ''}
              className={`object-cover w-full h-full rounded-lg ${classNameImg}`}
            />
            {showIcon && <span className="absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 z-[10]">
              <img src={PlayVideoBig} alt={''} />
            </span>}
            {showTime &&
              <div
                className="w-[50px] 
                bg-black/70 
                text-white 
                text-center 
                rounded-md 
                px-2
                absolute
                right-[5px]
                bottom-[10px] 
                py-1"
              >
                <span className="font-bold">{time}</span>
              </div>}

          </div>
          <p className="mt-2 text-[11px] text-dark line-clamp-2">{name}</p>
        </div>) :
        (<div className={`rounded-lg mb-5 ${className}`} onClick={handleClickToDetail}>
          <div className={`relative w-full h-[84px] ${active ? 'border-primary border-4 rounded-lg overflow-hidden' : ''}`}>
            <Image
              src={image || ''}
              alt={image || ''}
              className={`object-cover w-full h-full rounded-lg ${active ? 'rounded-none' : ''}`}
            />
            {showIcon && <span className="absolute top-[50%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 z-[10]">
              <img src={PlayVideo} alt={''} />
            </span>}

            <div className={`rounded-lg w-full absolute left-0 bottom-0 h-[50px]  ${active ? 'rounded-none' : ''}`}></div>
          </div>
          <p className="mt-2 text-[13px] text-dark line-clamp-2">{name}</p>

        </div>)
      }
      {isShowVideoYoutube && videoId && <VideoYoutube
        onClose={() => setShowVideoYoutube(false)}
        videoId={videoId}
      />}
      <CDialog
        open={isNotVideoId}
        handleSubmit={() => setIsNotVideoId(false)}
        hideCancel
        closeModal={() => setIsNotVideoId(false)}
        classNamechildren={'!py-2'}
        submitText={_t('main.close_btn')}
      >
        <p className="text-sm font-medium mb-4">
          {_t('main.not_video_id')}
        </p>
      </CDialog>
    </div>
  );
}

